import type { ComponentProps, ReactNode } from "react";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "../../components";

type ConfirmationDialogProps = {
	trigger: ReactNode;
	title: string;
	description: string;
	onConfirm: () => void;
	confirmationButtonText: string;
	cancelButtonText: string;
	variant?: ComponentProps<typeof AlertDialogAction>["variant"];
};

export const ConfirmationDialog = ({
	trigger,
	title,
	description,
	onConfirm,
	confirmationButtonText,
	cancelButtonText,
	variant,
}: ConfirmationDialogProps) => {
	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{title}</AlertDialogTitle>
					<AlertDialogDescription>
						{description}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>{cancelButtonText}</AlertDialogCancel>
					<AlertDialogAction
						variant={variant ?? "default"}
						onClick={onConfirm}
					>
						{confirmationButtonText}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
